import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RespDeptMakes } from "../incadea-interfaces/responses/ResponseDeptMakes.interface";
import { ResponseResources } from "../incadea-interfaces/responses/ResponseResources.interface";
import { incadeaEnvironment } from "src/environments/environment";
@Injectable({
    providedIn: 'root',
  })
export class GetResourcesService {

  
    constructor(private http: HttpClient,
       ) { 

        }
    public getResources(token:string,CompanyId:string, LocationId: string,backEndCode:string, department?:string) {
      
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`)
        .set('backend-code', `${backEndCode}`);
        const url = new URL(`${incadeaEnvironment.departments}/${CompanyId}/resources`);
        url.searchParams.append('LocationId', LocationId);
        url.searchParams.append('Department', department!);
        // Realiza la solicitud POST
       return  this.http.get<ResponseResources[]>(url.toString(), { headers })
      }
    }
  